import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export default function CommercialGlassPage() {
  const { t } = useTranslation('common');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const galleryImages = [
    {
      url: 'https://public.readdy.ai/ai/img_res/d5df5d1fba86de853e21f358801e6570.jpg',
      alt: 'Commercial Glass Curtain Wall'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Elegant%20commercial%20storefront%20with%20large%20glass%20display%20windows%20and%20polished%20aluminum%20frames%2C%20inviting%20retail%20entrance%20with%20transparent%20glass%20doors%20and%20professional%20signage%2C%20modern%20shop%20front%20with%20clean%20glass%20panels%20and%20warm%20interior%20lighting%20visible%2C%20sophisticated%20commercial%20facade%20with%20frameless%20glass%20and%20contemporary%20design%2C%20professional%20business%20entrance%20with%20floor%20to%20ceiling%20glass%20and%20welcoming%20atmosphere&width=800&height=600&seq=comm-gallery-02&orientation=landscape',
      alt: 'Commercial Storefront Glass'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Professional%20office%20interior%20with%20frameless%20glass%20partition%20walls%20creating%20open%20workspace%2C%20modern%20glass%20dividers%20with%20minimal%20aluminum%20frames%20separating%20meeting%20rooms%2C%20contemporary%20office%20design%20with%20transparent%20glass%20panels%20and%20natural%20light%20flow%2C%20sleek%20commercial%20interior%20with%20glass%20walls%20and%20collaborative%20work%20environment%2C%20clean%20business%20space%20with%20floor%20to%20ceiling%20glass%20partitions%20and%20professional%20atmosphere&width=800&height=600&seq=comm-gallery-03&orientation=landscape',
      alt: 'Glass Partition Systems'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Sophisticated%20commercial%20entrance%20with%20automatic%20sliding%20glass%20doors%20and%20stainless%20steel%20hardware%2C%20modern%20building%20lobby%20with%20large%20glass%20entry%20system%20and%20professional%20welcome%20area%2C%20contemporary%20commercial%20doorway%20with%20frameless%20glass%20panels%20and%20polished%20finishes%2C%20elegant%20business%20entrance%20with%20transparent%20glass%20doors%20and%20warm%20ambient%20lighting%2C%20professional%20building%20entry%20with%20sleek%20glass%20design%20and%20inviting%20atmosphere&width=800&height=600&seq=comm-gallery-04&orientation=landscape',
      alt: 'Commercial Glass Doors'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Modern%20commercial%20building%20with%20energy%20efficient%20Low-E%20glass%20windows%20reflecting%20blue%20sky%2C%20professional%20office%20exterior%20with%20tinted%20glass%20panels%20and%20aluminum%20frames%2C%20contemporary%20business%20building%20with%20reflective%20glass%20facade%20and%20sustainable%20design%2C%20sleek%20commercial%20architecture%20with%20high%20performance%20glazing%20and%20natural%20light%20optimization%2C%20professional%20corporate%20building%20with%20modern%20glass%20technology%20and%20environmental%20efficiency&width=800&height=600&seq=comm-gallery-05&orientation=landscape',
      alt: 'Energy Efficient Commercial Glass'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Elegant%20commercial%20glass%20railing%20system%20with%20frameless%20panels%20and%20stainless%20steel%20posts%2C%20modern%20office%20balcony%20with%20transparent%20glass%20guardrails%20and%20professional%20safety%20design%2C%20contemporary%20commercial%20interior%20with%20sleek%20glass%20barriers%20and%20minimalist%20hardware%2C%20sophisticated%20business%20space%20with%20floor%20mounted%20glass%20railings%20and%20clean%20architectural%20lines%2C%20professional%20building%20with%20transparent%20safety%20glass%20and%20polished%20metal%20accents&width=800&height=600&seq=comm-gallery-06&orientation=landscape',
      alt: 'Glass Railing Systems'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Professional%20commercial%20glass%20canopy%20entrance%20with%20structural%20glazing%20and%20steel%20supports%2C%20modern%20building%20awning%20with%20transparent%20glass%20panels%20and%20architectural%20design%2C%20contemporary%20commercial%20entrance%20with%20overhead%20glass%20shelter%20and%20clean%20lines%2C%20sleek%20business%20entry%20with%20glass%20canopy%20and%20weather%20protection%2C%20sophisticated%20commercial%20exterior%20with%20frameless%20glass%20overhang%20and%20professional%20appearance&width=800&height=600&seq=comm-gallery-07&orientation=landscape',
      alt: 'Glass Canopy Systems'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Modern%20commercial%20conference%20room%20with%20frosted%20glass%20walls%20for%20privacy%2C%20professional%20office%20meeting%20space%20with%20etched%20glass%20panels%20and%20contemporary%20design%2C%20sophisticated%20business%20interior%20with%20translucent%20glass%20partitions%20and%20natural%20light%2C%20elegant%20commercial%20space%20with%20decorative%20frosted%20glass%20and%20minimalist%20frames%2C%20professional%20workspace%20with%20privacy%20glass%20and%20collaborative%20environment&width=800&height=600&seq=comm-gallery-08&orientation=landscape',
      alt: 'Decorative Commercial Glass'
    }
  ];

  const openLightbox = (index: number) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'ArrowRight') nextImage();
    if (e.key === 'ArrowLeft') prevImage();
    if (e.key === 'Escape') closeLightbox();
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[70vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://readdy.ai/api/search-image?query=Impressive%20modern%20commercial%20glass%20building%20exterior%20with%20floor%20to%20ceiling%20curtain%20wall%20system%2C%20professional%20corporate%20architecture%20with%20sleek%20aluminum%20frames%20and%20reflective%20glass%20panels%2C%20contemporary%20business%20district%20with%20towering%20glass%20facade%20and%20clean%20geometric%20design%2C%20sophisticated%20commercial%20property%20with%20transparent%20walls%20and%20natural%20daylight%2C%20professional%20office%20building%20with%20modern%20glazing%20technology%20and%20architectural%20excellence&width=1920&height=1080&seq=comm-hero-main&orientation=landscape"
            alt="Commercial Glass Solutions"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/40"></div>
        </div>
        <div className="relative z-10 text-center text-white px-6 max-w-4xl mx-auto">
          <p className="text-amber-400 text-xs font-semibold tracking-[0.2em] mb-4 uppercase">
            {t('commercialGlass.badge')}
          </p>
          <h1 className="text-5xl md:text-6xl font-light mb-6 leading-tight">
            {t('commercialGlass.heroTitle')}
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-8 font-light leading-relaxed">
            {t('commercialGlass.heroSubtitle')}
          </p>
          <a
            href="/#contact"
            className="inline-block bg-amber-600 hover:bg-amber-700 text-white px-8 py-3.5 rounded-lg text-sm font-medium transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            {t('commercialGlass.ctaButton')}
          </a>
        </div>
      </section>

      {/* Overview Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-light text-stone-800 mb-6">
              {t('commercialGlass.overviewTitle')}
            </h2>
            <p className="text-stone-600 text-base leading-relaxed max-w-3xl mx-auto font-light">
              {t('commercialGlass.overviewDesc')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-stone-50 p-6 rounded-xl border border-stone-100 hover:border-amber-200 hover:shadow-lg transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg mb-4">
                <i className="ri-building-line text-amber-600 text-xl"></i>
              </div>
              <h3 className="text-base font-semibold text-stone-800 mb-2">
                {t('commercialGlass.feature1')}
              </h3>
              <p className="text-stone-500 text-sm leading-relaxed">
                {t('commercialGlass.feature1Desc')}
              </p>
            </div>

            <div className="bg-stone-50 p-6 rounded-xl border border-stone-100 hover:border-amber-200 hover:shadow-lg transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg mb-4">
                <i className="ri-shield-check-line text-amber-600 text-xl"></i>
              </div>
              <h3 className="text-base font-semibold text-stone-800 mb-2">
                {t('commercialGlass.feature2')}
              </h3>
              <p className="text-stone-500 text-sm leading-relaxed">
                {t('commercialGlass.feature2Desc')}
              </p>
            </div>

            <div className="bg-stone-50 p-6 rounded-xl border border-stone-100 hover:border-amber-200 hover:shadow-lg transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg mb-4">
                <i className="ri-leaf-line text-amber-600 text-xl"></i>
              </div>
              <h3 className="text-base font-semibold text-stone-800 mb-2">
                {t('commercialGlass.feature3')}
              </h3>
              <p className="text-stone-500 text-sm leading-relaxed">
                {t('commercialGlass.feature3Desc')}
              </p>
            </div>

            <div className="bg-stone-50 p-6 rounded-xl border border-stone-100 hover:border-amber-200 hover:shadow-lg transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg mb-4">
                <i className="ri-tools-line text-amber-600 text-xl"></i>
              </div>
              <h3 className="text-base font-semibold text-stone-800 mb-2">
                {t('commercialGlass.feature4')}
              </h3>
              <p className="text-stone-500 text-sm leading-relaxed">
                {t('commercialGlass.feature4Desc')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Styles Section */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-light text-stone-800 mb-4">
              {t('commercialGlass.stylesTitle')}
            </h2>
            <p className="text-stone-600 text-base font-light">
              {t('commercialGlass.stylesSubtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-xl border border-stone-200 hover:border-amber-200 hover:shadow-lg transition-all duration-300">
              <div className="w-full h-48 mb-4 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20commercial%20building%20with%20impressive%20glass%20curtain%20wall%20system%2C%20floor%20to%20ceiling%20aluminum%20framed%20glass%20panels%20creating%20sleek%20professional%20exterior%2C%20contemporary%20corporate%20architecture%20with%20reflective%20glazing%20and%20clean%20geometric%20lines%2C%20sophisticated%20business%20building%20with%20transparent%20facade%20and%20natural%20light%20optimization%2C%20professional%20commercial%20property%20with%20modern%20curtain%20wall%20technology&width=600&height=400&seq=comm-style-01&orientation=landscape"
                  alt="Curtain Wall Systems"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <h3 className="text-base font-semibold text-stone-800 mb-2">
                {t('commercialGlass.style1')}
              </h3>
              <p className="text-stone-500 text-sm leading-relaxed">
                {t('commercialGlass.style1Desc')}
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl border border-stone-200 hover:border-amber-200 hover:shadow-lg transition-all duration-300">
              <div className="w-full h-48 mb-4 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20commercial%20storefront%20with%20large%20display%20windows%20and%20polished%20aluminum%20frames%2C%20inviting%20retail%20entrance%20with%20transparent%20glass%20panels%20and%20professional%20design%2C%20modern%20shop%20front%20with%20floor%20to%20ceiling%20glass%20and%20warm%20interior%20lighting%2C%20sophisticated%20commercial%20facade%20with%20frameless%20glass%20doors%20and%20contemporary%20style%2C%20professional%20business%20entrance%20with%20clean%20glass%20and%20welcoming%20atmosphere&width=600&height=400&seq=comm-style-02&orientation=landscape"
                  alt="Storefront Glass"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <h3 className="text-base font-semibold text-stone-800 mb-2">
                {t('commercialGlass.style2')}
              </h3>
              <p className="text-stone-500 text-sm leading-relaxed">
                {t('commercialGlass.style2Desc')}
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl border border-stone-200 hover:border-amber-200 hover:shadow-lg transition-all duration-300">
              <div className="w-full h-48 mb-4 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20office%20interior%20with%20frameless%20glass%20partition%20walls%2C%20modern%20workspace%20with%20transparent%20glass%20dividers%20and%20minimal%20aluminum%20frames%2C%20contemporary%20commercial%20interior%20with%20floor%20to%20ceiling%20glass%20panels%20and%20natural%20light%2C%20sleek%20business%20environment%20with%20glass%20walls%20separating%20meeting%20rooms%2C%20clean%20office%20design%20with%20glass%20partitions%20and%20collaborative%20atmosphere&width=600&height=400&seq=comm-style-03&orientation=landscape"
                  alt="Glass Partitions"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <h3 className="text-base font-semibold text-stone-800 mb-2">
                {t('commercialGlass.style3')}
              </h3>
              <p className="text-stone-500 text-sm leading-relaxed">
                {t('commercialGlass.style3Desc')}
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl border border-stone-200 hover:border-amber-200 hover:shadow-lg transition-all duration-300">
              <div className="w-full h-48 mb-4 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Sophisticated%20commercial%20entrance%20with%20automatic%20sliding%20glass%20doors%20and%20stainless%20steel%20hardware%2C%20modern%20building%20lobby%20with%20large%20glass%20entry%20system%20and%20professional%20design%2C%20contemporary%20commercial%20doorway%20with%20frameless%20glass%20panels%20and%20polished%20finishes%2C%20elegant%20business%20entrance%20with%20transparent%20doors%20and%20warm%20lighting%2C%20professional%20building%20entry%20with%20sleek%20glass%20and%20inviting%20atmosphere&width=600&height=400&seq=comm-style-04&orientation=landscape"
                  alt="Commercial Doors"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <h3 className="text-base font-semibold text-stone-800 mb-2">
                {t('commercialGlass.style4')}
              </h3>
              <p className="text-stone-500 text-sm leading-relaxed">
                {t('commercialGlass.style4Desc')}
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl border border-stone-200 hover:border-amber-200 hover:shadow-lg transition-all duration-300">
              <div className="w-full h-48 mb-4 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20commercial%20glass%20railing%20system%20with%20frameless%20transparent%20panels%20and%20stainless%20steel%20posts%2C%20modern%20office%20balcony%20with%20glass%20guardrails%20and%20professional%20safety%20design%2C%20contemporary%20commercial%20interior%20with%20sleek%20glass%20barriers%20and%20minimalist%20hardware%2C%20sophisticated%20business%20space%20with%20floor%20mounted%20glass%20railings%20and%20clean%20lines%2C%20professional%20building%20with%20transparent%20safety%20glass%20and%20polished%20accents&width=600&height=400&seq=comm-style-05&orientation=landscape"
                  alt="Glass Railings"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <h3 className="text-base font-semibold text-stone-800 mb-2">
                {t('commercialGlass.style5')}
              </h3>
              <p className="text-stone-500 text-sm leading-relaxed">
                {t('commercialGlass.style5Desc')}
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl border border-stone-200 hover:border-amber-200 hover:shadow-lg transition-all duration-300">
              <div className="w-full h-48 mb-4 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20commercial%20glass%20canopy%20entrance%20with%20structural%20glazing%20and%20steel%20supports%2C%20modern%20building%20awning%20with%20transparent%20glass%20panels%20and%20architectural%20design%2C%20contemporary%20commercial%20entrance%20with%20overhead%20glass%20shelter%20and%20clean%20lines%2C%20sleek%20business%20entry%20with%20glass%20canopy%20and%20weather%20protection%2C%20sophisticated%20exterior%20with%20frameless%20glass%20overhang%20and%20professional%20appearance&width=600&height=400&seq=comm-style-06&orientation=landscape"
                  alt="Glass Canopies"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <h3 className="text-base font-semibold text-stone-800 mb-2">
                {t('commercialGlass.style6')}
              </h3>
              <p className="text-stone-500 text-sm leading-relaxed">
                {t('commercialGlass.style6Desc')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-light text-stone-800 mb-4">
              {t('commercialGlass.galleryTitle')}
            </h2>
            <p className="text-stone-600 text-base font-light">
              {t('commercialGlass.gallerySubtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {galleryImages.map((image, index) => (
              <div
                key={index}
                className="relative overflow-hidden rounded-lg cursor-pointer group aspect-[4/3]"
                onClick={() => openLightbox(index)}
              >
                <img
                  src={image.url}
                  alt={image.alt}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <i className="ri-zoom-in-line text-white text-2xl"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
          onKeyDown={handleKeyDown}
          tabIndex={0}
        >
          <button
            onClick={closeLightbox}
            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center text-white hover:text-amber-400 transition-colors cursor-pointer z-10"
            aria-label="Close"
          >
            <i className="ri-close-line text-3xl"></i>
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
            className="absolute left-6 w-12 h-12 flex items-center justify-center text-white hover:text-amber-400 transition-colors cursor-pointer"
            aria-label="Previous"
          >
            <i className="ri-arrow-left-s-line text-4xl"></i>
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
            className="absolute right-6 w-12 h-12 flex items-center justify-center text-white hover:text-amber-400 transition-colors cursor-pointer"
            aria-label="Next"
          >
            <i className="ri-arrow-right-s-line text-4xl"></i>
          </button>

          <div className="max-w-6xl max-h-[90vh] w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={galleryImages[currentImageIndex].url}
              alt={galleryImages[currentImageIndex].alt}
              className="w-full h-full object-contain"
            />
            <div className="text-center mt-4 text-white text-sm">
              {currentImageIndex + 1} / {galleryImages.length}
            </div>
          </div>
        </div>
      )}

      {/* Benefits Section */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-light text-stone-800 mb-4">
              {t('commercialGlass.benefitsTitle')}
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="flex gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                <i className="ri-lightbulb-line text-amber-600 text-xl"></i>
              </div>
              <div>
                <h3 className="text-base font-semibold text-stone-800 mb-2">
                  {t('commercialGlass.benefit1')}
                </h3>
                <p className="text-stone-500 text-sm leading-relaxed">
                  {t('commercialGlass.benefit1Desc')}
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                <i className="ri-eye-line text-amber-600 text-xl"></i>
              </div>
              <div>
                <h3 className="text-base font-semibold text-stone-800 mb-2">
                  {t('commercialGlass.benefit2')}
                </h3>
                <p className="text-stone-500 text-sm leading-relaxed">
                  {t('commercialGlass.benefit2Desc')}
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                <i className="ri-flashlight-line text-amber-600 text-xl"></i>
              </div>
              <div>
                <h3 className="text-base font-semibold text-stone-800 mb-2">
                  {t('commercialGlass.benefit3')}
                </h3>
                <p className="text-stone-500 text-sm leading-relaxed">
                  {t('commercialGlass.benefit3Desc')}
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                <i className="ri-hammer-line text-amber-600 text-xl"></i>
              </div>
              <div>
                <h3 className="text-base font-semibold text-stone-800 mb-2">
                  {t('commercialGlass.benefit4')}
                </h3>
                <p className="text-stone-500 text-sm leading-relaxed">
                  {t('commercialGlass.benefit4Desc')}
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                <i className="ri-money-dollar-circle-line text-amber-600 text-xl"></i>
              </div>
              <div>
                <h3 className="text-base font-semibold text-stone-800 mb-2">
                  {t('commercialGlass.benefit5')}
                </h3>
                <p className="text-stone-500 text-sm leading-relaxed">
                  {t('commercialGlass.benefit5Desc')}
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                <i className="ri-customer-service-2-line text-amber-600 text-xl"></i>
              </div>
              <div>
                <h3 className="text-base font-semibold text-stone-800 mb-2">
                  {t('commercialGlass.benefit6')}
                </h3>
                <p className="text-stone-500 text-sm leading-relaxed">
                  {t('commercialGlass.benefit6Desc')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-amber-600 to-amber-700">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-light text-white mb-6">
            {t('commercialGlass.ctaTitle')}
          </h2>
          <p className="text-white/90 text-base mb-8 leading-relaxed font-light">
            {t('commercialGlass.ctaDesc')}
          </p>
          <a
            href="/#contact"
            className="inline-block bg-white hover:bg-stone-100 text-amber-700 px-8 py-3.5 rounded-lg text-sm font-medium transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            {t('commercialGlass.ctaButton')}
          </a>
        </div>
      </section>
    </div>
  );
}